import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PrestationDossierTableMetierService} from './prestation-dossier-table.metier.service';
import {Autowired} from '@angular-ru/autowired';
import {SgiListLayoutComponent} from '@shared/behaviors/list-layout/sgi/sgi-list-layout.component';
import {FormGroup} from '@angular/forms';
import {CommonUtilities} from '@app/core/utilities/common.utilities';

@Component({
  selector: 'app-prestation-dossier-table',
  templateUrl: './prestation-dossier-table.component.html'
})

export class PrestationDossierTableComponent extends SgiListLayoutComponent implements OnInit {
  @Autowired() recuperationListeDonneesMetier: PrestationDossierTableMetierService;
  @Autowired() metierService: PrestationDossierTableMetierService;

  @Input() modalAssureSelected: any;
  @Input() responsePrestations: any;
  formGroup: FormGroup;
  typeRechercheCombo: any[] = [];
  placeholderInputSearch: string;
  @Output() responsePrestationsEvent = new EventEmitter<any>();

  /**
   *
   */

  currentDataTemp: any;
  tabActive = 'Prescriptions';
  responsePrestationsActe: any;
  responseAffections: any;
  responsePrescriptions: any;
  responsePrescriptionsRealise: any;


  constructor() {
    super();
    this.cols = [
      {field: 'datePrestation', header: 'Date prestation', type: () => 'date'},
      {field: 'raisonSociale', header: 'Prestataire '},
      {field: 'numBonPriseEnCharge', header: 'Num Bon Pec'},
    ];
    this.tableActions = [];
    this.notRowActions = [];
  }

  ngOnInit(): void {
    this.initialiserTypeRechercheCombo();

    this.initFormulaire();

    this.formatTableListAddIndex(this.responsePrestations);
  }

  /**
   * Définition des arguments
   */
  defineArgs(): void {
    super.defineArgs();
    const arg = {...this.args};
    this.args = {...arg};
  }

  recuperationDonnees(data?: any) {
    const da = {...this.args, lazyLoadEvent: data, successMute: true, assure: this.modalAssureSelected};
    this.args = {...da};
    // tslint:disable-next-line:max-line-length
    this.metierService.requeteRecuperationListeDonnees(this.getAllRequestParam(), {...this.args}).subscribe((r_Prestations) => {
      const responsePrestations = r_Prestations.body;

      this.formatTableListAddIndex(responsePrestations);

      this.responsePrestationsEvent.emit(r_Prestations.body);
    });
  }

  formatTableListAddIndex(responseData) {
    if (responseData === undefined) {
      this.dataSource = [];
      this.totalRecords = 0;
      return;
    }
    this.dataSource = responseData.items;
    this.totalRecords = responseData.count;
    if (this.dataSource && this.dataSource.length > 0) {
      this.dataSource.forEach((dat, index) => {
        dat.id_key = index + 1;
      });
    }
  }

  initFormulaire() {
    this.formGroup = this.metierService.initialiserFormulaire(null);
  }

  initialiserTypeRechercheCombo() {
    this.placeholderInputSearch = 'Rechercher';
    this.typeRechercheCombo = [
      { label: 'Date prestation', value: 'date_prestation'},
      { label: 'Prestataire', value: 'prestataire'},
      { label: 'Num. Bon PEC', value: 'num_bon_pec'}
    ];
  }

  handleChangeTypeRecherche(event: any) {
    if (event.value === null) {
      this.placeholderInputSearch = 'Rechercher';

      this.formGroup.patchValue({ inputSearch: null });

      // fonction de recherche assuré avec les valeurs null
      this.recuperationDonnees();
    }

    if (event.value === 'date_prestation') {
      this.placeholderInputSearch = 'Rechercher par date';
    }

    if (event.value === 'prestataire') {
      this.placeholderInputSearch = 'Rechercher par prestataire';
    }

    if (event.value === 'num_bon_pec') {
      this.placeholderInputSearch = 'Rechercher par num. bon PEC';
    }

    this.formGroup = this.metierService.initialiserFormulaire(this.formGroup.getRawValue());
  }

  recherchePrestation(event) {
    if (this.formGroup.getRawValue().selectTypeSearch === null) { return false; }

    // fonction de recherche assuré avec les valeurs entrées
    this.recuperationDonnees();
  }

  /**
   *
   */

  /**
   * Reccupère la ligne courante du tableau lorsqu'elle est sélectionnée
   */
  selectCurrentRow(data?: any) {
    this.currentRow = null;
    this.currentDataTemp = null;
    this.tabViewFirstLevelActive = 0;
    this.tabActive = 'Prescriptions';

    this.currentRow = data;
    this.currentDataTemp = this.currentRow;

    if (data !== null) {
      // this.getPrestationActesResultatsExamen(data);
    }
  }

  getTabChange(event) {
    this.currentRow = null;
    this.tabActive = '';

    this.currentRow = this.currentDataTemp;
    this.tabActive = event.originalEvent.target['innerText'];
  }

  /**
   * => return true, si l'objet est vide
   */
  isEmptyObject(obj) {
    return CommonUtilities.isEmptyObject(obj);
  }

  getPrestationActesResultatsExamen(args) {
    this.metierService.requeteGetPrestationActesResultatsExamen({}, args).subscribe((response) => {
      console.log('getPrestationActesResultatsExamen : ', response);
    });
  }

  handleResponsePrestationsActe(event: any) {
    this.responsePrestationsActe = event;
  }

  handleResponseAffections(event: any) {
    this.responseAffections = event;
  }

  handleResponsePrescriptions(event: any) {
    this.responsePrescriptions = event;
  }

  handleResponsePrescriptionsRealise(event: any) {
    this.responsePrescriptionsRealise = event;
  }

}
